module.exports = __webpack_public_path__ + "static/media/bigboxLightGreen-Artboard_1.8b4da6ed.png";